import theme from '@dbk/ui-theme';

export const DBK16_PALETTE = {
  midGrey: '#A7A8AA',
  brightBlue: '#00A3E0',
  midnightBlue: '#000E28',
  white: '#FFFFFF',
  gradientBlue: '#011533',
  prussianBlue: '#023154',
  paleBlue: '#A4C8E1',
  darkGrey: '#535B61',
  warningYellow: '#F2A900',
  coralRed: '#FF4433',
  turquoiseGreen: '#00C7B1',
  darkBlue: '#00205B',
  dawnBlue: '#12213C',
  secondaryBG: '#13223b',
  warningOrange: '#FFA550'
}

export const DBK16_PRIMARY_ACTIVE = DBK16_PALETTE.white;
export const DBK16_SECONDARY_ACTIVE = DBK16_PALETTE.brightBlue;
export const DBK16_TERTIARY_ACTIVE = DBK16_PALETTE.midGrey;
export const DBK16_BG_FIRST_GRADIENT = DBK16_PALETTE.gradientBlue;
export const DBK16_BG_SECOND_GRADIENT = DBK16_PALETTE.midnightBlue;

export const DBK16_FONT_FAMILY = {
  DB_DISPLAY : theme.fontFamilyMedium,  // 'DeutscheBank-Medium',
  DB_REGULAR: theme.fontFamilyRegular, 
}

export const DBK16_FONT_SIZE = {
  SMALL :12,
  NORMAL: 14,
  MEDIUM: 16, 
  LARGE: 18,
  LARGEST: 20,
  HEADER0: 40,  // aligning with DBK
  HEADER1: 32,
  HEADER2: 28,
  HEADER3: 24,
  XSMALL: 10,
}

export const DBK16_ICON_SIZE = {
  DEFAULT: 24,
  xsmall:20,
  small: 22,
  normal: 24,
  medium: 26,
  midLarge:30,
  large: 32,
  xlarge: 35
}
